"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var components_1 = require("../../components");
var icons_1 = require("@ant-design/icons");
// import '@ant-design/compatible/assets/index.css';
var antd_1 = require("antd");
var react_intl_1 = require("react-intl");
// import {defineMessages} from "react-intl.macro"
var NewBillingLines_1 = __importDefault(require("./NewBillingLines"));
var BillingCalculations_1 = __importDefault(require("./BillingCalculations"));
var BillingTaxSummary_1 = __importDefault(require("./BillingTaxSummary"));
exports.translationMessages = react_intl_1.defineMessages({
    billingLines_title: {
        id: "billingLines_title",
        defaultMessage: "Document lines",
    },
    billingLines_tooltip_title: {
        id: "billingLines_tooltip_title",
        defaultMessage: "Item number, Name, Quantity, Unit of measure, Unit price amount Tax category and Discount need to be defined here.\n" + "VAT is automatically applied.\n" +
            "Click \"Add a row\" to add a new line",
    },
    // billingLines_itemNo: {
    //     id: "billingLines_itemNo",
    //     defaultMessage: "Item no",
    // },
    // billingLines_name: {
    //     id: "billingLines_name",
    //     defaultMessage: "Name"
    // },
    // billingLines_quantity: {
    //     id: "billingLines_quantity",
    //     defaultMessage: "Quantity"
    // },
    // billingLines_unitOfMeasure: {
    //     id: "billingLines_unitOfMeasure",
    //     defaultMessage: "Unit of measure"
    // },
    // billingLines_unitPriceAmount: {
    //     id: "billingLines_unitPriceAmount",
    //     defaultMessage: "Unit price amount"
    // },
    // billingLines_taxCategoryType: {
    //     id: "billingLines_taxCategoryType",
    //     defaultMessage: "Tax category"
    // },
    // billingLines_taxCategoryType_title: {
    //     id: "billingLines_taxCategoryType_title",
    //     defaultMessage: "A product can not contain VAT unless a VAT number is present" // Ekki er hægt að leggja virðisauka á vöru nema gefa upp VSK númer
    // },
    // billingLines_taxCategoryPercentage: {
    //     id: "billingLines_taxCategoryPercentage",
    //     defaultMessage: "Tax percentage"
    // },
    // billingLines_discount: {
    //     id: "billingLines_discount",
    //     defaultMessage: "Discount"
    // },
    // billingLines_lineAmount: {
    //     id: "billingLines_lineAmount",
    //     defaultMessage: "Amount"
    // },
    // billingLines_taxAmount: {
    //     id: "billingLines_taxAmount",
    //     defaultMessage: "Tax inclusive amount"
    // },
    billingLines_button_addRow: {
        id: "billingLines_button_addRow",
        defaultMessage: "Add a row"
    },
    billingLines_placeholders_itemNo: {
        id: "billingLines_placeholders_itemNo",
        defaultMessage: "Item No"
    },
    billingLines_placeholders_newItem: {
        id: "billingLines_placeholders_newItem",
        defaultMessage: "New Item"
    },
});
var BillingLines = /** @class */ (function (_super) {
    __extends(BillingLines, _super);
    // columns: EditableColumnProps<BillingLineMetadataOverride>[];
    function BillingLines(props) {
        return _super.call(this, props) || this;
        // this.columns = [
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_itemNo),
        //         dataIndex: 'itemNo',
        //         editable: true,
        //         width: "12em",
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_name),
        //         dataIndex: 'name',
        //         editable: true,
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_quantity),
        //         dataIndex: 'quantity',
        //         editable: true,
        //         align: "right",
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_unitOfMeasure),
        //         dataIndex: 'unitOfMeasure',
        //         align: "right",
        //         editable: true,
        //         render: ((text, record) => {
        //             return <span>{this.props.intl.formatMessage(commonTranslationMessages[`unitOfMeasure_labels_${record.unitOfMeasure.value}` as keyof typeof commonTranslationMessages])}</span>
        //         })
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_unitPriceAmount),
        //         dataIndex: 'unitPriceAmount',
        //         editable: true,
        //         align: "right",
        //         render: (text, record) => {
        //             return icelandicNumberLocaleWorkaroundChrome(record.unitPriceAmount ? record.unitPriceAmount : 0, props.intl);
        //         }
        //         // render: this.renderCurrencyColumn,
        //     },
        //     {
        //         title: (
        //             <Tooltip
        //                 title={this.props.intl.formatMessage(translationMessages.billingLines_taxCategoryType_title)}
        //                 placement={"right"}
        //             >
        //                 <span>{this.props.intl.formatMessage(translationMessages.billingLines_taxCategoryType)}&nbsp;<QuestionCircleOutlined/></span>
        //             </Tooltip>
        //         ),
        //         dataIndex: 'taxCategoryType',
        //         align: "right",
        //         editable: true,
        //         render: ((text, record) => {
        //             const taxPercentage = calculateTaxPercentage(TaxCategoryTypeEnum[record.taxCategoryType.value]);
        //             return <span>{`${this.props.intl.formatMessage(commonTranslationMessages[`taxCategoryType_labels_${record.taxCategoryType.value}` as keyof typeof commonTranslationMessages])} (${taxPercentage}%)`}</span>
        //         })
        //     },
        //     // {
        //     //     title: this.props.intl.formatMessage(translationMessages.billingLines_taxCategoryPercentage),
        //     //     dataIndex: 'taxCategoryPercentage',
        //     //     editable: false,
        //     //     align: "right",
        //     //     render: ((text, record) => {
        //     //         const taxPercentage = calculateTaxPercentage(TaxCategoryTypeEnum[record.taxCategoryType]); // BillingLineMetadataTaxCategoryTypeEnum -> TaxCategoryTypeEnum
        //     //         return <span>{taxPercentage}%</span>
        //     //     })
        //     // },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_discount),
        //         dataIndex: 'discountValue',
        //         editable: true,
        //         align: "right",
        //         width: "5em",
        //         render: ((text, record) => {
        //             return <div>{record.discountValue}</div>
        //         })
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_lineAmount),
        //         dataIndex: 'taxableAmount',
        //         editable: false,
        //         align: "right",
        //         render: (text, record) => {
        //             const taxableAmount = calculateTaxableAmount(record.discountValue, record.quantity, record.unitPriceAmount);
        //             return (
        //                 <span>{icelandicNumberLocaleWorkaroundChrome(taxableAmount, props.intl, {style: "decimal"})}</span>
        //             );
        //         }
        //     },
        //     {
        //         title: this.props.intl.formatMessage(translationMessages.billingLines_taxAmount),
        //         dataIndex: 'taxInclusiveAmount',
        //         editable: false,
        //         align: "right",
        //         render: (text, record) => {
        //             const taxAmount = calculateTaxAmount(calculateTaxableAmount(record.discountValue, record.quantity, record.unitPriceAmount), calculateTaxPercentage(TaxCategoryTypeEnum[record.taxCategoryType.value])); // BillingLineMetadataTaxCategoryTypeEnum -> TaxCategoryTypeEnum
        //             const taxableAmount = calculateTaxableAmount(record.discountValue, record.quantity, record.unitPriceAmount);
        //             const taxInclusiveAmount = taxableAmount + taxAmount;
        //             return (
        //                 <span>{icelandicNumberLocaleWorkaroundChrome(taxInclusiveAmount, props.intl, {style: "decimal"})}</span>
        //             );
        //         }
        //     },
        //     {
        //         title: "",
        //         render: (text, record) => {
        //             return <>
        //                 <MinusCircleOutlined
        //                     onClick={() => {
        //                         this.props.handleDelete(record.key);
        //                     }}/>
        //             </>;
        //         }
        //     }
        // ]
    }
    // renderCurrencyColumn = (text: string | number) => {
    //     const currency = this.props.formInstance.getFieldValue(["invoice", "currencyCode"]) ? this.props.formInstance.getFieldValue(["invoice", "currencyCode"]) : "";
    //     return text + " " + currency;
    // };
    BillingLines.prototype.render = function () {
        // const dataSource = this.props.formInstance.getFieldValue(["invoice", "invoiceLines"]);
        // const {dataSource} = this.props;
        // const components = {
        //     body: {
        //         row: EditableRow,
        //         cell: EditableCell,
        //     },
        // };
        // const columns: ColumnsType<BillingLineMetadataOverride> = this.columns.map(col => {
        //     if (!col.editable) {
        //         return col;
        //     }
        //     return {
        //         ...col,
        //         onCell: (record: BillingLineMetadataOverride) => ({
        //             record,
        //             editable: col.editable,
        //             dataIndex: col.dataIndex,
        //             title: col.title ? col.title.toString() : "", // TODO: will this work?????
        //             handleSave: (billingLineMetadataOverrideRecord: BillingLineMetadataOverride, rowIndex: number) => this.props.handleSave(billingLineMetadataOverrideRecord, this.props.formInstance),
        //         }),
        //     };
        // });
        var billingLinesLabelNode = (React.createElement(antd_1.Tooltip, { title: this.props.intl.formatMessage(exports.translationMessages.billingLines_tooltip_title), placement: "right" },
            React.createElement("span", null,
                this.props.intl.formatMessage(exports.translationMessages.billingLines_title),
                "\u00A0",
                React.createElement(icons_1.QuestionCircleOutlined, null))));
        var currencyCode = this.props.formInstance.getFieldValue(["invoice", "currencyCode"]) ? this.props.formInstance.getFieldValue(["invoice", "currencyCode"]) : "";
        var billingLinesFormValues = this.props.formInstance.getFieldsValue(["invoice", "invoiceLines"]);
        return (React.createElement(components_1.ComponentContainer, { title: billingLinesLabelNode },
            React.createElement(NewBillingLines_1.default, { formInstance: this.props.formInstance, receiverRequirements: this.props.receiverRequirements, outsideVatScope: this.props.outsideVatScope }),
            React.createElement(antd_1.Row, { style: { marginTop: "1em" }, align: "top", justify: "space-between", gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 16 },
                    React.createElement(BillingTaxSummary_1.default
                    // billingLines={this.props.billingLinesMetadata}
                    , { 
                        // billingLines={this.props.billingLinesMetadata}
                        formInstance: this.props.formInstance, outsideVatScope: this.props.outsideVatScope })),
                React.createElement(antd_1.Col, { span: 8 },
                    React.createElement(BillingCalculations_1.default
                    // billingLinesMetadata={this.props.billingLinesMetadata}
                    // renderCurrencyColumn={this.renderCurrencyColumn}
                    , { 
                        // billingLinesMetadata={this.props.billingLinesMetadata}
                        // renderCurrencyColumn={this.renderCurrencyColumn}
                        currencyCode: currencyCode, formInstance: this.props.formInstance, outsideVatScope: this.props.outsideVatScope })))));
    };
    return BillingLines;
}(React.Component));
var BillingLinesIntl = react_intl_1.injectIntl(BillingLines);
exports.default = BillingLinesIntl;
